import React from 'react'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { default as useUploadDocument } from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { ResidualValueAdjustmentDetailContent } from './ResidualValueAdjustmentDetailContent'
import { ResidualValueDetailContent } from './ResidualValueDetailContent'

export const ResidualValueDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, ResidualValueID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    clearErrors,
  } = useForm<any>()
  const [audioInput, setAudioInput] = useState('')
  const [record, setRecord] = useState(false)
  const [text, setText] = useState(mode === 'add' ? '' : editData?.remark)
  const [singleRemark, setSingleRemark] = useState(null)
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  let itemData = []
  itemData = editData?.ResidualValueID

  const {
    files,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
    setFiles,
  } = useUploadDocument()

  const dummyData = [
    {
      Name: 'Machinery',
      AssetNo: 'A-000013',
      OriginalAmount: 200000,
      ModelNo: 'N/A',
      ResidualValue: 10000000,
      Description: 'Change description here',
      StartDate: '2023-10-01T12:44:01.162Z',
      Reason: 'Reason here...',
      OriginalPercent: 0,
      ResidualPercent: 0,
      SubmittedBy: 'Syima',
      ApprovedBy: 'Leong Koh',
      SubmittedDate: '2023-10-01T12:44:01.162Z',
      ApprovedDate: '2023-10-03T12:44:01.162Z',
      ResidualAdjustment: [
        {
          ResidualPercent: 0,
          ResidualValue: 100000,
          Description: 'Change description here',
          Reason: 'Change reason here',
        },
      ],
      ApprovalStatus: 'COMPLETED',
    },
  ]

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    error: getUsersByAccountAndSoftwareError,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftwareData: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const rejectFooterOption = {
    name: 'Reject',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'secondary',
    props: { type: 'submit' },
  }

  const approveFooterOption = {
    name: 'Approve',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }
  const footerOptions: any[] = [rejectFooterOption, approveFooterOption]

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/residual-value`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Residual Value' },
        ]}
        rightRouteSegments={[{ name: 'Approved', current: true }]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{dummyData[0]?.Name}</span>
          </span>
        }
        rightText={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{dummyData[0]?.AssetNo}</span>
          </span>
        }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', width: '270px' }}
          >
            <span>
              <span style={{ textDecoration: 'line-through' }}>{`${amtNumStr(
                dummyData[0].OriginalAmount
              )} | ${dummyData[0].OriginalPercent}% `}</span>
              <span style={{ color: 'orange' }}>&#10230;</span>
              <span style={{ color: 'limegreen' }}>{` ${amtNumStr(
                dummyData[0]?.ResidualValue
              )} | ${dummyData[0]?.ResidualPercent}%`}</span>
            </span>
          </div>
        }
        rightInfoLine={<span>{formatDate(dummyData[0]?.StartDate)}</span>}
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <ResidualValueDetailContent
            listEl={dummyData[0]}
            listStatus={dummyData[0]?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Residual (%) Adjustment' },
          }}
        >
          <ResidualValueAdjustmentDetailContent listAdjustment={dummyData[0]} />
        </CardContents>
      </ContentWrapper>

      {mode === 'workdesk' ? <Footer options={[...footerOptions]} /> : null}

      {dummyData[0]?.ApprovalStatus === 'SUBMIT' ? (
        <Footer
          options={[
            {
              name: 'Post',
              onClick: () => {},
              color: 'primary',
            },
          ]}
        />
      ) : null}

      <RejectDialog
        data={dummyData[0]}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        audioInput={audioInput}
        record={record}
        setRecord={setRecord}
        setValue={setValue}
        errors={errors}
        register={register}
        control={control}
        clearErrors={clearErrors}
        setText={setText}
        handleSingleRemark={handleSingleRemark}
      />
    </>
  )
}
